export enum CharacterEnum {
  Empty = '',
  Comma = ',',
  Colon = ':',
  Hyphen = '-',
  Percent = '%',
  Semicolon = ';',
  Slash = '/',
  Pipe = '|',
}
